// extracted by mini-css-extract-plugin
var _1 = "LobwO";
var _2 = "SMPLF";
var _3 = "vwbqV";
var _4 = "YpoC3";
export { _1 as "body", _2 as "header", _3 as "terms", _4 as "title" }
